module.exports = __webpack_public_path__ + "img/3.c95e6540.jpg";